/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_IdempotencyInputs */

const en_svchip_idempotency = /** @type {(inputs: Svchip_IdempotencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idempotency`)
};

const ar_svchip_idempotency = /** @type {(inputs: Svchip_IdempotencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المماثلة`)
};

const bn_svchip_idempotency = /** @type {(inputs: Svchip_IdempotencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আইডেমপোটেন্সি`)
};

const de_svchip_idempotency = /** @type {(inputs: Svchip_IdempotencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idempotenz`)
};

const es_svchip_idempotency = /** @type {(inputs: Svchip_IdempotencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idempotencia`)
};

const fr_svchip_idempotency = /** @type {(inputs: Svchip_IdempotencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idempotence`)
};

const pt_svchip_idempotency = /** @type {(inputs: Svchip_IdempotencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idempotência`)
};

const zh_svchip_idempotency = /** @type {(inputs: Svchip_IdempotencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`幂等性`)
};

const tr_svchip_idempotency = /** @type {(inputs: Svchip_IdempotencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İdempotans`)
};

const ru_svchip_idempotency = /** @type {(inputs: Svchip_IdempotencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идемпотентность`)
};

const pl_svchip_idempotency = /** @type {(inputs: Svchip_IdempotencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idempotencja`)
};

/**
* | output |
* | --- |
* | "Idempotency" |
*
* @param {Svchip_IdempotencyInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_idempotency = /** @type {((inputs?: Svchip_IdempotencyInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_IdempotencyInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_idempotency(inputs)
	if (locale === "bn") return bn_svchip_idempotency(inputs)
	if (locale === "de") return de_svchip_idempotency(inputs)
	if (locale === "es") return es_svchip_idempotency(inputs)
	if (locale === "fr") return fr_svchip_idempotency(inputs)
	if (locale === "pt") return pt_svchip_idempotency(inputs)
	if (locale === "zh") return zh_svchip_idempotency(inputs)
	if (locale === "tr") return tr_svchip_idempotency(inputs)
	if (locale === "ru") return ru_svchip_idempotency(inputs)
	if (locale === "pl") return pl_svchip_idempotency(inputs)
	return en_svchip_idempotency(inputs)
});